export default interface IThresholdSettings {
    id: string;
    key: string;
    name: string;
    colorCode: string;
    isActive?: boolean;
}

export class ThresholdSettings implements IThresholdSettings {
    id: string;
    key: string;
    name: string;
    colorCode: string;
    isActive?: boolean;

    constructor(id: string,
        key: string,
        name: string,
        colorCode: string,
        isActive?: boolean
        ) {

        this.id = id;
        this.key = key;
        this.name = name;
        this.colorCode = colorCode;
        this.isActive = true;
    }
}

const defaultThresholdSettingData = new ThresholdSettings("", "", "", "");
export { defaultThresholdSettingData }